var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "management-page-outer-container" },
    [
      _c("router-view"),
      _vm._v(" "),
      _vm.$route.name === "workspaces-management"
        ? _c(
            "div",
            { staticClass: "data-table management-main-list-data-table" },
            [
              _c(
                "workspace-data-table",
                {
                  attrs: {
                    "pagination-from-parent": _vm.pagination,
                    "search-from-parent": _vm.search
                  },
                  on: {
                    "update-pagination": function($event) {
                      _vm.pagination = $event
                    },
                    "update-search": function($event) {
                      _vm.search = $event
                    }
                  }
                },
                [
                  _c("management-add-button", {
                    attrs: {
                      label: _vm.$t("AddWorkspace"),
                      disabled: !_vm.hasNeededPermissionsTo(
                        _vm.addButtonMissingPermissions
                      ),
                      listMissingPermissions: _vm.addButtonMissingPermissions
                    },
                    on: {
                      buttonClick: function($event) {
                        return _vm.$router.push({ name: "workspace-create" })
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4dc31632", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4dc31632","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProjectManagement/Workspaces/Workspace.vue
// module id = null
// module chunks = 